import React, {useLayoutEffect, useState} from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import { css } from "styled-components/macro"; //eslint-disable-line


import Header, { NavLink, NavLinks, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";

const Heading = tw.h1`z-40 text-xl sm:text-3xl md:text-4xl lg:text-3xl text-white leading-none absolute bottom-[-200%] 
right-[20px] text-center font-bold tracking-wider font-serif`;

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none w-full`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`font-sans text-gray-100 text-base hover:border-gray-300 hover:text-gray-300 font-thin uppercase 
    tracking-widest`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;

const imgList = ["/localadra/IMG-20220902-WA0014.jpg", "/localadra/IMG_20230129_122128.jpg",
  "/localadra/IMG_20190131_091810.jpg", "/localadra/IMG_20200424_171433.jpg", "/localadra/IMG_20220721_150447.jpg",
  "/localadra/IMG_20210129_172341.jpg", "/localadra/IMG_20220715_194132.jpg",
  "/localadra/IMG_20220918_164334.jpg", "/localadra/IMG_20230110_155256.jpg",
  "/localadra/IMG_20230110_155634.jpg", "/localadra/PXL_20220320_140859045_2.jpg",
  "/localadra/PXL_20220918_094230097.jpg" ];

const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-40 flex flex-col bg-black/[0.25]`;

const Container =
    styled.div`
  ${tw`overflow-hidden z-30 relative -mx-8 -mt-8 bg-center h-96 lg:h-screen min-h-144`}
`;

export default () => {
  const { t } = useTranslation();

  const [count, setCount] = useState(0);

  const Content = styled.div`${tw`animate-expand -z-1 h-screen bg-cover -mt-40`}
  background-image: url(${imgList[count]});`;

  useLayoutEffect(() => {
    setInterval(() => {
      setCount((count) => count === (imgList.length - 1) ? 0 : count + 1)
    }, 5000);
  }, []);


  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="#">
        {t('menu.home')}
      </NavLink>
      <NavLink href="#chi-siamo">
        {t('menu.who')}
      </NavLink>
      <NavLink href="/#ospitalita">
        {t('menu.hospitality')}
      </NavLink>
      <NavLink href="#contatti">
        {t('menu.contacts')}
      </NavLink>
      <NavLink href="#footer">
        {t('menu.dove')}
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
    </NavLinks>
  ];


  return (
     <Container>
       <HeroContainer>
         <StyledHeader links={navLinks} />
         <Heading></Heading>
       </HeroContainer>
       <Content>
       </Content>
     </Container>
  );
};
